// throttleGlobal.js - versione aggiornata per supportare Promise

const globalTimestamps = {};

/**
 * Crea una funzione con throttling globale che supporta le Promise.
 *
 * @param {string} key - Identificatore univoco dell'operazione
 * @param {Function} func - La funzione (può restituire una Promise)
 * @param {number} limit - Intervallo minimo in ms (default: 60000ms = 1 minuto)
 * @return {Function} - Funzione con throttling che restituisce sempre una Promise
 */
export function throttleGlobal(key, func, limit = 60000) {
    return async function(...args) {
        const now = Date.now();
        const lastRun = globalTimestamps[key] || 0;
        
        // Verifica se è passato abbastanza tempo
        if (now - lastRun >= limit) {
            globalTimestamps[key] = now;
            
            // Esegui la funzione originale e gestisci il caso in cui sia una Promise
            const result = func.apply(this, args);
            
            // Se la funzione restituisce una Promise, la attendiamo
            if (result instanceof Promise) {
                return await result;
            }
            
            // Altrimenti, restituiamo il risultato direttamente
            return result;
                
        } else {
            // Throttling attivo - restituisci una Promise rejected o resolved con un valore speciale
            // return Promise.reject(new Error());
            
            // Alternativa: restituire una Promise resolved con un valore speciale
            return Promise.resolve({ ignored: true, message: `Funzione "${key}" ignorata (throttling attivo con limite di una ogni ${ limit / 1000 }s).` });
        }
    };
}